export default {
    typographyExample: "'Example', 'Example Fallback'",
    primary: "'ABC Monument Grotesk Variable', 'ABC Monument Grotesk Variable Fallback'",
    secondary: "'Martina Plantijn', 'Martina Plantijn Fallback'",
} as const;
